import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import type { CustomerMetadata } from '../models/customer-metadata.model';
import type { CustomerLookupStrategy } from './customer-lookup.strategy';

/**
 * A mock implementation of the customer lookup strategy.
 * Returns hardcoded data, useful for local development and testing.
 */
@Injectable()
export class MockCustomerLookupStrategy implements CustomerLookupStrategy {
  /**
   * Returns mock customer metadata.
   * @param _domain The domain (ignored in mock implementation).
   * @returns An observable emitting mock customer metadata.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  lookup(_domain: string): Observable<CustomerMetadata> {
    // TODO: Replace with proper logging service
    // Using mock customer data for development/testing
    const mockData: CustomerMetadata = {
      primaryDomain: 'gafetest.com',
      googleCustomerId: 'C04cu9ga4',
      cdwCustomerId: 2,
    };
    return of(mockData);
  }
}
